module.exports = __webpack_public_path__ + "img/book-06.2e8f4b6a.png";